<ng-template #loader>
  <app-spinner></app-spinner>
</ng-template>

<app-modal
  [activeModal]="activeModal"
  [isCloseDisabled]="form.pristine || !form.valid || isSaving"
  [onClose]="submit"
  [closeBtnLabel]="closeBtnLabel"
  [title]="title"
>
  <form [formGroup]="form" class="flex flex-col gap-6">
    <app-domain-error></app-domain-error>

    <p>
      <label for="odbiorcy-select" class="form-label" i18n>Odbiorcy</label>
      <app-sss-select
        [displayOnlyFirstProperty]="true"
        [dataSource]="odbiorcySource"
        [inputId]="'odbiorcy-select'"
        [reactiveControl]="odbiorcySelectControl"
        [displayProperty]="['nazwa', 'email']"
        [isMultiple]="true"
        [valueProperty]="null"
        (add)="onAddOdbiorca($event)"
        (remove)="onRemoveOdbiorca($event)"
        (valueChange)="onOdbiorcyChange($event)"
      >
      </app-sss-select>
      <span class="form-text text-danger" *ngIf="odbiorcySelectControl.touched && !odbiorcySelectControl.valid" i18n
        >To pole jest wymagane.</span
      >
    </p>

    <p>
      <label for="temat-input" class="form-label" i18n>Temat</label>
      <input type="text" id="temat-input" formControlName="temat" class="form-control" />
      <span class="form-text text-danger" *ngIf="shouldDisplayTypeOfError('temat', 'required')" i18n
        >To pole jest wymagane.</span
      >
      <span *ngIf="shouldDisplayTypeOfError('temat', 'maxlength')" class="form-text text-danger" i18n
        >Przekroczono dopuszczalną liczbę znaków.</span
      >
      <app-text-counter
        [currentLength]="form.get('temat').value?.length"
        [maxLength]="maxTematLength"
      ></app-text-counter>
    </p>

    <div>
      <div #contentsValue>
        <label for="wiadomosc-input" class="form-label" i18n>Wiadomość</label>
        <app-text-editor
          id="wiadomosc-input"
          [initialContent]="form.get('tresc').value"
          (valueChanges)="onChangeContentValue($event)"
        ></app-text-editor>
        <span *ngIf="shouldDisplayTypeOfError('tresc', 'maxlength')" class="form-text text-danger" i18n
          >Przekroczono dopuszczalną liczbę znaków.</span
        >
        <span *ngIf="lastDraftEditTime">
          <ng-container i18n>Zapisano wersję roboczą: </ng-container>{{ lastDraftEditTime | date: 'HH:mm' }}
        </span>
      </div>
    </div>

    <section *ngIf="zalaczniki && zalaczniki?.length">
      <h6><ng-container i18n>Załączniki</ng-container> ({{ zalaczniki.length }})</h6>
      <ul *ngFor="let file of zalaczniki" class="list-unstyled">
        <li class="flex items-center gap-4">
          <button ndt-tertiary-button type="button" (click)="downloadFile(file)">
            <app-icon name="file-download"></app-icon>{{ file.nazwaZalacznika }}
          </button>
          <button
            ndt-icon-button
            type="button"
            aria-label="Usuń"
            i18n-aria-label
            appConfirmationModal="delete"
            (confirmed)="deleteAttachment(file.id)"
          >
            <app-icon name="trash"></app-icon>
          </button>
        </li>
      </ul>
    </section>

    <div class="flex items-center gap-4">
      <button ndt-tertiary-button type="button" [disabled]="isSaving || !recordId" (click)="attachmentInput.click()">
        <app-icon *ngIf="!loaderControl.attachmentLoad; else loader" name="linked"></app-icon>
        <ng-container i18n>Dodaj załącznik</ng-container>
      </button>
      <input type="file" hidden class="hidden" (change)="onUploadAttachmentFile($event)" #attachmentInput />
      <button
        ndt-tertiary-button
        type="button"
        (click)="handleSaveDraftBtnClick()"
        [disabled]="form.pristine || !form.valid || isSaving"
      >
        <app-icon *ngIf="!loaderControl.draftModeLoad; else loader" name="file-alt"></app-icon>
        <ng-container i18n>Zapisz wersję roboczą</ng-container>
      </button>
    </div>
  </form>
</app-modal>
